export const convertPriceValueToFloat = (priceValue: number, forceDecimal = false) => {
  if (forceDecimal) {
    return (priceValue / 100).toFixed(2)
  }

  return priceValue.toString().length > 2 ? priceValue / 100 : priceValue
}
